import React, { Component } from 'react';
import CanvasDraw from "react-canvas-draw";
import {
    Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea, Loading
} from 'carbon-components-react';
import { fileUpload, api } from '../../../helpers/api/api';
import { v4 as uuid } from 'uuid';
import { ComboBox } from '../../../helpers/ComboBox'
import { Erase16 } from '@carbon/icons-react';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import { entitiesLabels } from '../../../helpers/Constants';
import AuditImgSignature from './AuditImgSignature'
/**
 * Modal inserimento firma dei Partecipanti
 *      key: string
 *      title: string
 *      editModel: obj
 *      isOpenModal: bool
 *      toggleModal: fn
 *      save: fn
 *      idTraining: guid
 */
export default class AuditModalSignature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                ...this.props.editModel
            },
            StoragePath: 'audit',
            isSubmitted: false,
            flagSignature: true,
            showCanvas: this.props.editModel && !this.props.editModel.signatureAttachment,
        }
    }

    componentDidMount() {
    }

    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model')
            statusCopy[objName][inputName] = inputValue;
        else
            statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy });
    }


    updateSignature = () => {
        this.setState({ flagSignature: false });
    }

    clearImage = () => {
        if (this.props.editModel && this.props.editModel.sendedBy) {
            this.setState({ showCanvas: true , flagSignature:true});
        }
        if (this.saveableCanvas) {
            this.saveableCanvas.clear();
            this.setState({ flagSignature:true});
        }
    }

    showLoading() {
        return (this.state.isSubmitted && <Loading active={true} withOverlay={true} description={"Saving..."} />);
    }

    save = async () => {
        this.setState({ 'isSubmitted': true });
        let dati = this.state.model;

        try {
            let fileIdentifier = await this.saveImage();
            if (fileIdentifier != null) {
                dati.signatureAttachment = fileIdentifier;
            }
            else if ((fileIdentifier == null && dati.signatureAttachment == null) || this.state.showCanvas){
                dati.signatureAttachment = null;
            }

            await api.put(`/audit/signature/${this.props.editModel.signatureAttachment}`,dati);

            this.props.save(dati);
            showNotification.success(`${entitiesLabels.SUCCESS}`,"Signature saved successfully");
        } catch {
            showNotification.error(`${entitiesLabels.ERROR}`,"Error saving Signature");
        } finally {
            this.setState({ 'isSubmitted': false });
        }
    }

    saveImage = async () => {
        if (this.saveableCanvas) {
            const canvas = this.saveableCanvas.canvasContainer.children[1];
            if (canvas == null || isCanvasBlank(canvas)) {
                //showNotification.warning("Warning: required fields are missing  ");
                return null;
            }
            this.setState({ 'isSubmitted': true });
            const csvURL = canvas.toDataURL();
            const base64 = csvURL.split(',')[1];
            const fileAsBlob = base64toBlob(base64, 'image/png');

            const fileName = `sg${uuid()}.png`;

            const blobAsFile = new File([fileAsBlob], fileName, {
                type: 'image/png',
            });

            const fileIdentifier = `${this.state.StoragePath}_${new Date().getTime()}_${fileName}`;

            const formData = new FormData();
            formData.append('File', blobAsFile);
            formData.append('Container', 'saipem');
            formData.append('StoragePath', this.state.StoragePath);
            formData.append('FileIdentifier', fileIdentifier);

            await fileUpload.post(formData);
            return fileIdentifier;
        }
        return null;
    }

    render() {
        if (this.props.editModel == null) return null;
        const showCanvas = this.state.showCanvas;
       
        return (      
           
        
                <div className="bx--modal bx--modal-tall is-visible box-medium-modal">
                 <div className="bx--modal-container">            
                  <div className="bx--modal-header">
                  <p>Please fill the box with your signature (Not Mandatory) and Confirm to proceed</p>
            
                    </div>
                    
                    <ModalBody className="margin-modal">
                    {this.showLoading()}
                    <div className="bx--col-lg-12 bx--col-md-12">
                      
                        <div className="bx--row row-content canvas-sign">
                            <div className="bx--col-lg-12 bx--col-md-12">
                               
                            </div>
                            {showCanvas ?
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <CanvasDraw
                                        ref={canvasDraw => (this.saveableCanvas = canvasDraw)}
                                        onChange={this.state.flagSignature?  this.updateSignature : null }
                                        loadTimeOffset={0}
                                        lazyRadius={2}
                                        brushRadius={2}
                                        brushColor="#444"
                                        catenaryColor="#0a0302"
                                        gridColor="rgba(150,150,150,0.17)"
                                        hideGrid={false}
                                        canvasWidth={473}
                                        canvasHeight={200}
                                        disabled={false}
                                        imgSrc=""
                                        saveData={null}
                                        immediateLoading={false}
                                        hideInterface={true}
                                    />
                                    <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                  
                                </div>
                                :
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <div>
                                        <AuditImgSignature auditNotification={ this.state.model} />
                                    </div>
                                    <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                  
                                </div>
                            }
                        </div>
                    </div>
                   
                </ModalBody>
              
                  <div className="bx--modal-footer">
                    <Button
                      className="button--max-width"
                      kind="secondary"
                      onClick={() => this.props.toggleModal(false)}
                      //chiusura modale e basta
                    >
                      Cancel
                    </Button>
                    <Button
                      className="button--max-width"
                      kind="primary"
                      onClick={() => this.save()}
                     // disabled={this.state.flagSignature ? true : this.state.model.signatureAttachment && !showCanvas  }
                    >
                      Confirm
                    </Button>
                  </div>
                </div>
              </div>
                  
                
                
        );
    }
}


function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = window.atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

function isCanvasBlank(canvas) {
    return !canvas.getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height).data
        .some(channel => channel !== 0);
}